import React, { Component, push } from "react";
import { withRouter } from "react-router-dom";
import {
  Grommet,
  Box,
  Header,
  Button,
  Menu,
  Main,
  Heading,
  Paragraph,
  Footer,
  Text,
  Anchor,
  DropButton,
  Stack,
  Avatar,
  TextInput,
  Grid,
  Card,
  Form,
  FormField,
  CheckBoxGroup,
  Select,
  CardHeader,
  CardBody,
  List,
  Image,
  CheckBox,
  DateInput,
  Tabs,
  Tab,
  Layer,
  Accordion,
  AccordionPanel,
  Spinner,
  Meter,
} from "grommet";
import {
  Hpe,
  More,
  Help,
  Channel,
  Console,
  Notification,
  Search,
  New,
  Like,
  Directions,
  Favorite,
  FormPrevious,
  Filter,
  Dislike,
  Chat,
  Share,
  Download,
  ScheduleNew,
  Launch,
  AddCircle,
  Edit,
  Trash,
  Validate,
  Clear,
  Play,
  Multimedia,
  DocumentPdf,
  Inspect,
  Close,
  Alert,
  Link,
} from "grommet-icons";
import { hpe as theme } from "grommet-theme-hpe";

class InfoWarning extends Component {
  constructor(props) {
    super(props);
    this.openGLCP = this.openGLCP.bind(this);
  }

  componentDidMount() {}

  openGLCP() {
    window.open("https://common.cloud.hpe.com/", "_blank");
  }

  render() {
    return (
      <Main flex="grow" fill="vertical" overflow="auto">
        <Layer animate modal={false}>
          <Box align="center" justify="center">
            <Box
              align="center"
              justify="center"
              background={{ color: "white" }}
              fill="horizontal"
              // margin="medium"
            >
              <Box
                align="center"
                justify="center"
                direction="row"
                gap="medium"
                fill="horizontal"
                margin="medium"
              >
                <Alert size="large" color="orange" />
                {/*                 <Heading size="small" level="4" margin="small">
                  Alert
                </Heading> */}
              </Box>
            </Box>
            <Box align="center" justify="center" margin="small">
              {this.props.isGLUsrIssue && (
                <Text size="medium">
                  Your Greenlake user status is unverified.
                  <br /> Please click link icon to open{" "}
                  <Button
                    primary
                    icon={<Link color="black" size="medium" />}
                    hoverIndicator="grey"
                    color="brand"
                    tip="Greenlake cloud"
                    //fill={true}
                    onClick={this.openGLCP}
                  />{" "}
                  Greenlake Cloud Platform <br />
                  Once opened , please close this message and launch this demo
                  again from Demo Portal.
                </Text>
              )}
              {!this.props.isGLUsrIssue && (
                <Text size="medium">{this.props.message}</Text>
                /*                 <Heading size="small" level="4" margin="small">
                  {this.props.message}
                </Heading> */
              )}
            </Box>
            <Box
              align="center"
              justify="center"
              direction="row"
              gap="large"
              margin="medium"
            >
              <Button
                label="OK"
                active={false}
                primary
                reverse
                type="button"
                onClick={this.props.hide}
              />
            </Box>
          </Box>
        </Layer>
      </Main>
    );
  }
}

export default InfoWarning;
